
  export default {
    name: 'About',
    created(){
        document.title = "Garage de Vuyst"
    }
  }
